<template>
<v-row>
    <v-col cols="12" md="12">
        <s-crud
            ref="crud"
            no-border
            :formPermanent="!showMassUpload"
            title="Comprobantes gratuitos"
            height="auto"
            :refreshTable="refreshTableKey"
            :config="this.config"
            @save="save($event)"
            :add="!showMassUpload"
            :edit="!showMassUpload"
            sortable
            @rowSelected="rowSelected($event)"
            searchInput
        >
            <template slot-scope="props">
                <v-row class="mb-2" align="center">
                    <!-- Botón -->
                    <v-col cols="12" md="2">
                        <v-btn outlined color="success" block @click="toggleMassUpload()">
                            Carga masiva
                        </v-btn>
                    </v-col>

                    <!-- Input -->
                    <v-col cols="12" md="6" v-show="showMassUpload">
                        <v-file-input
                            v-model="massFile"
                            dense
                            hide-details
                            outlined
                            prepend-icon=""
                            prepend-inner-icon="mdi-paperclip"
                            accept=".xlsx,.xls"
                            label="Seleccionar Excel"
                            @change="onMassFileChange"
                        />
                    </v-col>

                    <!-- Botón subir -->
                    <v-col cols="12" md="2" v-show="showMassUpload">
                        <v-btn 
                            outlined 
                            color="info" 
                            block 
                            :disabled="processingMass || massRows.length === 0" 
                            @click="uploadMassive()"
                        >
                            Subir
                        </v-btn>
                    </v-col>

                    <!-- Contador -->
                    <v-col cols="12" md="2" class="text-right" v-show="showMassUpload">
                        <div v-if="massRows.length > 0">
                            {{ massRows.length }} filas
                        </div>
                    </v-col>
                </v-row>
                <v-container v-if="!showMassUpload && props.item != null && ensureDefaults(props.item)" class="pb-0">
                    <v-row justify="center" >
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.Serie" label="Serie" autofocus />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.Correlativo" label="Correlativo" />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.Moneda" label="Moneda" defaultValue="PEN" />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.ImpInafecto" label="ImpInafecto"  decimal />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.BI" label="BI"  decimal @input="recalcTotal(props.item)" />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.IGV" label="IGV"  decimal @input="recalcTotal(props.item)" />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.Total" label="Total"  decimal readonly />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </s-crud>
    </v-col>
</v-row>
</template>

<script>
import _sVoucherFree from "@/services/Accounting/ConVoucherFree";
import * as XLSX from "xlsx";
export default {
    components: {},
    data: () => ({
        itemsMoneda: [
            { value: "PEN", text: "PEN" },
            { value: "USD", text: "USD" },
        ],
        showMassUpload: false,
        massFile: null,
        massRows: [],
        processingMass: false,
        refreshTableKey: 0,
        config: {
            model: {
                VfrID: "ID",
                Serie: "string",
                Correlativo: "string",
                ImpInafecto: "decimal",
                BI: "decimal",
                IGV: "decimal",
                Total: "decimal",
                Moneda: "string"
            },

            service: _sVoucherFree,
            headers: [{
                    text: "ID",
                    value: "VfrID",
                    sorteable: false,
                },
                {
                    text: "Serie",
                    value: "Serie",
                    sorteable: false,
                },
                {
                    text: "Correlativo",
                    value: "Correlativo",
                    sorteable: false,
                },
                {
                    text: "Moneda",
                    value: "Moneda",
                    sorteable: false,
                },
                {
                    text: "ImpInafecto",
                    value: "ImpInafecto",
                    sorteable: false,
                },
                {
                    text: "BI",
                    value: "BI",
                    sorteable: false,
                },
                {
                    text: "IGV",
                    value: "IGV",
                    sorteable: false,
                },
                {
                    text: "Total",
                    value: "Total",
                    sorteable: false,
                }
            ],
        },
    }),
    created(){
        
    },
    methods: {
        toggleMassUpload() {
            this.showMassUpload = !this.showMassUpload;
            if (!this.showMassUpload) {
                this.massFile = null;
                this.massRows = [];
            }
        },
        async onMassFileChange(file) {
            this.massRows = [];
            if (!file) return;
            try {
                const rows = await this.parseExcelFile(file);
                this.massRows = rows;
                if (rows.length === 0) this.$fun.alert("El archivo no contiene filas válidas.", "warning");
            } catch (e) {
                this.massFile = null;
                this.massRows = [];
                this.$fun.alert("No se pudo leer el archivo Excel.", "error");
            }
        },
        parseExcelFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onerror = () => reject(reader.error);
                reader.onload = () => {
                    try {
                        const data = new Uint8Array(reader.result);
                        const workbook = XLSX.read(data, { type: "array" });
                        const sheetName = workbook.SheetNames && workbook.SheetNames.length > 0 ? workbook.SheetNames[0] : null;
                        if (!sheetName) {
                            resolve([]);
                            return;
                        }
                        const sheet = workbook.Sheets[sheetName];
                        const table = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true, defval: "" });
                        const mapped = this.mapVoucherRows(table);
                        resolve(mapped);
                    } catch (err) {
                        reject(err);
                    }
                };
                reader.readAsArrayBuffer(file);
            });
        },
        mapVoucherRows(table) {
            if (!Array.isArray(table) || table.length === 0) return [];
            const firstRow = Array.isArray(table[0]) ? table[0].map((x) => String(x || "").trim().toUpperCase()) : [];
            const looksLikeHeader = firstRow.includes("SERIE") || firstRow.includes("CORRELATIVO") || firstRow.includes("MONEDA");
            const startIndex = looksLikeHeader ? 1 : 0;

            const result = [];
            for (let i = startIndex; i < table.length; i++) {
                const r = table[i];
                if (!Array.isArray(r)) continue;
                const serie = String(r[0] || "").trim();
                const correlativo = String(r[1] || "").trim();
                const moneda = String(r[2] || "").trim() || "PEN";
                const impInafecto = this.parseDecimal(r[3]);
                const bi = this.parseDecimal(r[4]);
                const igv = this.parseDecimal(r[5]);
                const total = Number((bi + igv).toFixed(2));

                const isEmpty = !serie && !correlativo && !moneda && impInafecto === 0 && bi === 0 && igv === 0 && total === 0;
                if (isEmpty) continue;

                result.push({
                    VfrID: 0,
                    Serie: serie,
                    Correlativo: correlativo,
                    Moneda: moneda,
                    ImpInafecto: impInafecto,
                    BI: bi,
                    IGV: igv,
                    Total: total,
                });
            }
            return result;
        },
        async uploadMassive() {
            if (this.processingMass) return;
            if (!this.massRows || this.massRows.length === 0) {
                this.$fun.alert("Seleccione un archivo con datos.", "warning");
                return;
            }

            const confirm = await this.$fun.alert(`¿Seguro de cargar ${this.massRows.length} registros?`, "question");
            if (!confirm || !confirm.value) return;

            this.processingMass = true;
            let ok = 0;
            let fail = 0;
            let lastError = "";

            for (const row of this.massRows) {
                try {
                    const payload = Object.assign({}, row);
                    this.ensureDefaults(payload);
                    await _sVoucherFree.save(payload, this.$fun.getUserID());
                    ok++;
                } catch (e) {
                    fail++;
                    lastError = (e && e.response && e.response.data && (e.response.data.Message || e.response.data)) || (e && e.message) || "Error";
                }
            }
            this.showMassUpload = false;
            this.processingMass = false;
            this.massFile = null;
            this.massRows = [];
            this.refreshTableKey++;

            if (fail === 0) this.$fun.alert(`Carga masiva finalizada. Correctos: ${ok}`, "success");
            else this.$fun.alert(`Carga masiva finalizada. Correctos: ${ok} | Errores: ${fail}${lastError ? " | Último error: " + lastError : ""}`, "warning");
        },
        ensureDefaults(item) {
            if (item.Moneda == null || item.Moneda === "") item.Moneda = "PEN";
            if (item.ImpInafecto == null || item.ImpInafecto === "") item.ImpInafecto = 0;
            if (item.BI == null || item.BI === "") item.BI = 0;
            if (item.IGV == null || item.IGV === "") item.IGV = 0;
            if (item.Total == null || item.Total === "") item.Total = 0;
            this.recalcTotal(item);
            return true;
        },
        parseDecimal(value) {
            if (value == null) return 0;
            if (typeof value === "number") return isNaN(value) ? 0 : value;
            const raw = String(value).trim();
            if (!raw) return 0;
            const normalized = raw.replace(/\s/g, "").replace(",", ".");
            const n = Number(normalized);
            return isNaN(n) ? 0 : n;
        },
        recalcTotal(item) {
            if (!item) return;
            const bi = this.parseDecimal(item.BI);
            const igv = this.parseDecimal(item.IGV);
            item.Total = Number((bi + igv).toFixed(2));
        },
        rowSelected(items) {
            
        },
        save(item) {
           item.save()
        },
    },
    computed: {},
};
</script>
